import { render, staticRenderFns } from "./PosReceipts.vue?vue&type=template&id=38e47959&scoped=true"
import script from "./PosReceipts.vue?vue&type=script&lang=js"
export * from "./PosReceipts.vue?vue&type=script&lang=js"
import style0 from "./PosReceipts.vue?vue&type=style&index=0&id=38e47959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e47959",
  null
  
)

export default component.exports